/*----------------------------------------------------------------------------*\
    SETTINGS
    Global settings used throughout javascript
\*----------------------------------------------------------------------------*/

/**
 * Use strict as per:
 * http://ejohn.org/blog/ecmascript-5-strict-mode-json-and-more/
 */
'use strict';


/**
 * Check if oy object exists, otherwise create it
 */
var oy = oy || {};


/**
 * Jshint global references
 * Please define all third party plugins that you use to not break jshinting
 */



/*  Component
\*----------------------------------------------------------------------------*/

oy.settings = {
    transitions: {
        short: 200,
        medium: 600,
        long: 1000
    },
    space: Math.round(parseFloat(document.defaultView.getComputedStyle(document.body, null).getPropertyValue('line-height').replace('px', ''))),
    /**
     * EEEWWW, browser sniffing, (puke)
     * Gets and sets useragent on html element, needed for some super-specific hacks
     */
    setUserAgent: function(){
        var doc = document.documentElement;
        doc.setAttribute('data-useragent', navigator.userAgent);
    },
    embedHeightChangeName: 'embedHeightChange',
    embedHeightChange: new Event('embedHeightChange'),
    embedScrollChangeName: 'embedScrollChange',
    embedScrollChange: new Event('embedScrollChange')
};

window.addEventListener('load', function () {
    oy.settings.setUserAgent();
}, false);
